import React from 'react'
import PropTypes from 'prop-types'
import { motion, useAnimation } from 'framer-motion'

import { CARD_STARS } from 'constants/stars'
import Star from 'components/Landing/Star'

const ANIMATION_VARIANTS = {
  hidden: 'hidden',
  visible: 'visible'
}

const STARS_VARIANTS = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      type: 'easeInOut',
      duration: 1,
      delay: 0
    }
  }
}

function Member(props) {
  const { avatar, career, name, role } = props

  const controls = useAnimation()

  return (
    <div className="the-team__person">
      <div
        className="the-team__circle"
        onMouseEnter={() => controls.start(STARS_VARIANTS.visible)}
        onMouseLeave={() => controls.start(STARS_VARIANTS.hidden)}
      >
        <img className="the-team__avatar" src={avatar} alt={name} />
        {CARD_STARS.map((star) => (
          <motion.div
            key={`team-member-start-${star.position}`}
            variants={ANIMATION_VARIANTS}
            animate={controls}
            initial={{ opacity: 0 }}
          >
            <Star
              key={`member-star-${star.position}`}
              className={`the-team__star the-team__star--${star.position}`}
              reverse={star.reverse}
            />
          </motion.div>
        ))}
      </div>
      <div className="the-team__text-wrapper">
        <div className="the-team__text the-team__person-name">{name}</div>
        <div className="the-team__text the-team__person-role">{role}</div>
        <div className="the-team__text the-team__person-career">{career}</div>
      </div>
    </div>
  )
}

Member.propTypes = {
  avatar: PropTypes.node.isRequired,
  career: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired
}

export default Member
